import 'regenerator-runtime/runtime';
import { put, takeEvery } from 'redux-saga/effects';
import {
  DoRequestResponse,
  GlobalActions,
  HTTP_METHOD,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { ForkEffect, PutEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { appConfigLoaded, LoadAppConfigAction, LocalActions } from '../local.actions';
import { childAppsConfig } from '../../childAppsConfig';

// NOSONAR

export enum APP_CONFIG_LOAD_EVENTS {
  APP_CONFIG_LOAD_SUCCESSFUL = 'APP_CONFIG_LOAD_SUCCESSFUL',
  APP_CONFIG_LOAD_FAILED = 'APP_CONFIG_LOAD_FAILED',
}

export function* watchAppConfigRequested(): Generator<ForkEffect> {
  yield takeEvery(LocalActions.LOAD_APP_CONFIG, safeSaga(configRequested, App.SHOP));
  yield takeEvery(
    APP_CONFIG_LOAD_EVENTS.APP_CONFIG_LOAD_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP),
  );
  yield takeEvery(APP_CONFIG_LOAD_EVENTS.APP_CONFIG_LOAD_FAILED, safeSaga(errorCallback, App.SHOP));
}

export function* configRequested(action: LoadAppConfigAction): Generator<PutEffect> {
  const url = childAppsConfig.getConfigUrlForAppId(action.payload.appId);
  yield put(
    new GlobalActions().doRequest({
      appId: App.SHOP,
      url: `${url}?datetime=${getTimestamp()}`,
      successEvent: APP_CONFIG_LOAD_EVENTS.APP_CONFIG_LOAD_SUCCESSFUL,
      errorEvent: APP_CONFIG_LOAD_EVENTS.APP_CONFIG_LOAD_FAILED,
      method: HTTP_METHOD.GET,
      originEvent: action,
    }),
  );
}

export const getTimestamp = (): number => {
  return Date.now();
};

export function* successCallback(
  successAction: DoRequestResponse<{ main: string }>,
): Generator<PutEffect> {
  const originEvent = successAction.doRequestAction.payload.originEvent as LoadAppConfigAction;
  yield put(appConfigLoaded(originEvent.payload.appId, successAction.payload.main));
}

export function* errorCallback(): Generator<PutEffect> {
  yield put(new GlobalActions().errorPageRequested());
}
